import { useTrackAddMediaSideBarActionsAnalytics } from '../../../hooks/bi/useTrackAddMediaSideBarActionsAnalytics';
import { createHOCWithHookInside } from '../../createHOCWithHookInside';

/**
 * @deprecated use "useTrackAddMediaSideBarActionsAnalytics"
 */
export const withTrackAddMediaSideBarActionsAnalytics = createHOCWithHookInside(
  'WithTrackAddMediaSideBarActionsAnalytics',
  useTrackAddMediaSideBarActionsAnalytics,
);
